import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Mumbaitojalgaoncabbookingdhule() {



const cardData = {
  keyword: "Mumbai to Jalgaon Cab Booking / Dhule",

headingDescription:
  "Omshree Cab provides reliable and comfortable Mumbai to Jalgaon and Dhule cab services for travelers planning a hassle-free journey to North Maharashtra. Whether you are traveling for business, family visits, weekend trips, or group tours, our cab service ensures a safe, smooth, and convenient ride with experienced drivers and well-maintained vehicles. We offer flexible booking options including one-way, round-trip, and multi-day travel plans at transparent per-kilometer pricing. Our fleet features air-conditioned sedans, spacious SUVs, luxury cars, and tempo travelers suitable for solo travelers, families, and groups. With professional chauffeurs skilled in long-distance highway driving, punctual pickups from anywhere in Mumbai, and 24/7 customer support, Omshree Cab is your trusted partner for Mumbai to Jalgaon and Dhule cab services.",

topPlaces: [
  {
    title: "Ajanta Caves (Near Jalgaon)",
    description:
      "Ajanta Caves are UNESCO World Heritage rock-cut Buddhist caves near Jalgaon, renowned for their ancient sculptures, paintings, and intricate carvings. Visitors can explore the caves to witness remarkable artistry, religious history, and architectural brilliance. Traveling by cab ensures a comfortable and hassle-free journey, allowing tourists to spend ample time exploring the caves at their own pace without worrying about local transport."
  },
  {
    title: "Ellora Caves (Accessible from Jalgaon/Dhule)",
    description:
      "Ellora Caves, another UNESCO World Heritage site, feature rock-cut temples of Buddhism, Hinduism, and Jainism. The site is famous for Kailasa Temple, intricate carvings, and historical significance. A cab service allows visitors to travel conveniently from Mumbai, explore multiple caves comfortably, and manage the day efficiently without relying on local transport."
  },
  {
    title: "Vajreshwari Temple (Nearby Jalgaon)",
    description:
      "Vajreshwari Temple is a revered spiritual site near Jalgaon, dedicated to Lord Vishnu and Lord Shiva. Pilgrims can perform rituals, seek blessings, and enjoy the tranquil atmosphere. Traveling by cab ensures safe and comfortable access, allowing devotees to include this temple visit alongside other cultural and sightseeing stops."
  },
  {
    title: "Dhule Fort",
    description:
      "Dhule Fort is a historic fort with panoramic views of the surrounding area, offering insights into the region’s history. Visitors can explore the fort, enjoy photography, and learn about local heritage. A cab ride ensures convenient access, making it easy to combine the fort visit with other nearby attractions in Dhule."
  },
  {
    title: "Nardala Waterfall",
    description:
      "Nardala Waterfall near Jalgaon is a picturesque spot, ideal for nature lovers, photography, and picnics. Visitors can enjoy serene walks, explore surrounding greenery, and relax by the waterfall. Traveling by cab provides easy access and allows sufficient time to enjoy this natural attraction along with other sightseeing locations."
  },
  {
    title: "Ankai-Tankai Forts",
    description:
      "Ankai-Tankai Forts are twin forts near Jalgaon, popular among trekking enthusiasts and history buffs. Visitors can explore the forts, enjoy panoramic views, and experience cultural heritage. A cab service ensures comfortable transport to the base, enabling travelers to plan trekking and sightseeing without transport concerns."
  },
  {
    title: "Patnadevi Temple",
    description:
      "Patnadevi Temple, near Jalgaon, is a spiritual site dedicated to the goddess Patnadevi. Visitors can experience local rituals, peaceful surroundings, and cultural heritage. Traveling by cab allows convenient access and the flexibility to include this temple in a North Maharashtra sightseeing itinerary."
  },
  {
    title: "Shree Sai Baba Temple (Dhule)",
    description:
      "Shree Sai Baba Temple in Dhule attracts devotees for spiritual rituals, prayers, and meditation. Visitors can explore the temple complex, experience serene surroundings, and participate in local festivals. A cab ride provides hassle-free transport from Mumbai, ensuring comfort and convenience for pilgrims."
  },
  {
    title: "Ahirani Cultural Spots",
    description:
      "Jalgaon and Dhule regions are rich in Ahirani culture, including folk art, music, and local handicrafts. Travelers can explore these cultural spots, interact with locals, and experience authentic regional traditions. Traveling by cab allows seamless visits to these sites alongside other attractions in the region."
  },
  {
    title: "Girna Dam",
    description:
      "Girna Dam near Dhule offers scenic views, boating opportunities, and peaceful surroundings. Visitors can enjoy photography, picnics, and relaxing by the water. A cab ride ensures convenient access and flexibility to include this destination as part of a full day trip from Mumbai."
  }
],




services: [
{
name: "Mumbai to Jalgaon Cab",
description: "Mumbai to Jalgaon cab service provides comfortable and reliable intercity travel for passengers planning journeys between Mumbai and Jalgaon. Our fleet includes clean AC sedans, SUVs, and premium vehicles designed for long-distance highway travel. Professional drivers with excellent route knowledge ensure safe and punctual journeys. Pickup services are available from homes, hotels, offices, railway stations, and Mumbai airport terminals. This service is ideal for business travel, family trips, and personal visits. Spacious seating and air-conditioned interiors ensure relaxed travel throughout the journey. Flexible one-way and round-trip options allow convenient trip planning. Transparent pricing ensures a trusted and stress-free cab booking experience."
},
{
name: "Mumbai to Jalgaon Taxi",
description: "Mumbai to Jalgaon taxi service offers convenient transportation for passengers traveling across Maharashtra. Comfortable AC vehicles ensure a pleasant highway journey and relaxed travel conditions. Experienced drivers ensure safe driving and timely arrival at the destination. Pickup is available from homes, hotels, offices, and Mumbai airport terminals. Ideal for families, business travelers, and tourists. Clean interiors and spacious seating ensure passenger comfort throughout the journey. Flexible departure scheduling allows easy travel planning. Reliable taxi service ensures safe and comfortable travel between Mumbai and Jalgaon."
},
{
name: "Mumbai to Jalgaon Cab Service",
description: "Mumbai to Jalgaon cab service provides dependable road transportation for passengers traveling long distances. Our well-maintained AC vehicles ensure smooth highway travel and comfortable seating. Skilled drivers ensure safe driving along major routes connecting Mumbai and Jalgaon. Pickup is available across Mumbai including homes, offices, hotels, and airports. Ideal for family visits, corporate travel, and outstation journeys. Spacious vehicles provide comfortable seating for long-distance trips. Flexible booking options allow travelers to plan trips conveniently. Transparent pricing ensures reliable and affordable cab service."
},
{
name: "Mumbai to Jalgaon Taxi Service",
description: "Mumbai to Jalgaon taxi service offers efficient intercity transportation for passengers seeking safe and reliable travel. Our AC vehicles ensure comfortable highway journeys and pleasant travel conditions. Experienced drivers ensure safe driving and timely arrivals. Pickup services are available across Mumbai including homes, offices, hotels, and airport terminals. Ideal for business trips, family travel, and long-distance journeys. Spacious seating ensures passengers travel comfortably. Flexible booking options allow convenient travel planning. Affordable fares ensure a smooth and reliable taxi experience."
},
{
name: "Cab from Mumbai to Jalgaon",
description: "Cab from Mumbai to Jalgaon offers a private and comfortable travel option for passengers traveling between the two cities. Our AC vehicles ensure smooth highway travel and relaxed seating throughout the journey. Professional drivers ensure safe driving and punctual arrivals. Pickup services are available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for business travel, family visits, and long-distance trips. Spacious interiors ensure comfortable travel for passengers. Flexible departure timing allows convenient trip scheduling. Reliable cab services ensure safe and pleasant journeys."
},
{
name: "Taxi from Mumbai to Jalgaon",
description: "Taxi from Mumbai to Jalgaon provides dependable transportation for travelers seeking comfortable road travel. AC vehicles ensure pleasant journeys across highways and city routes. Experienced drivers ensure safe driving and timely arrival at the destination. Pickup is available from homes, offices, hotels, and airports across Mumbai. Ideal for family trips, business travel, and personal visits. Spacious seating and clean interiors ensure comfortable travel. Flexible booking options allow convenient scheduling. Professional taxi services ensure reliable intercity travel."
},
{
name: "Mumbai to Jalgaon Cab Booking",
description: "Mumbai to Jalgaon cab booking allows travelers to reserve vehicles easily for long-distance travel. Online and phone booking options provide instant confirmation and convenient scheduling. AC sedans and SUVs ensure comfortable highway journeys. Professional drivers ensure safe and punctual travel experiences. Pickup is available across Mumbai including homes, hotels, offices, and airport terminals. Ideal for business travel, family trips, and tourism. Flexible one-way and round-trip booking options are available. Reliable booking services ensure smooth and hassle-free travel planning."
},
{
name: "Mumbai to Jalgaon Taxi Booking Online",
description: "Mumbai to Jalgaon taxi booking online offers quick and easy reservation for travelers planning intercity trips. Instant booking confirmation helps passengers plan travel without delays. Comfortable AC vehicles ensure smooth highway journeys. Experienced drivers ensure safe and professional driving services. Pickup is available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for tourists, families, and corporate travelers. Flexible travel timing allows passengers to choose convenient departure times. Reliable booking systems ensure stress-free taxi reservations."
},
{
name: "Mumbai to Jalgaon Cab Price",
description: "Mumbai to Jalgaon cab price offers affordable and transparent travel options for passengers planning outstation journeys. Clear fare details help travelers understand travel costs before booking. Our fleet includes sedans, SUVs, and premium vehicles suited for various travel needs. Comfortable seating and AC interiors ensure relaxed travel throughout the journey. Professional drivers ensure safe highway travel. Pickup services are available across Mumbai including airport terminals. Flexible travel options allow passengers to choose one-way or round-trip travel. Budget-friendly pricing ensures convenient and reliable cab service."
},
{
name: "Mumbai to Jalgaon Taxi Fare",
description: "Mumbai to Jalgaon taxi fare is calculated using transparent per-kilometer pricing to ensure clear and affordable travel costs. Passengers can select vehicles based on comfort and budget preferences. AC vehicles ensure smooth highway travel across long distances. Experienced drivers guarantee safe driving and punctual arrival. Pickup services are available from homes, hotels, offices, and airports across Mumbai. Ideal for family travel and corporate trips. Flexible booking options allow easy travel planning. Reliable taxi fare systems ensure stress-free booking."
},
{
name: "Mumbai to Dhule Cab",
description: "Mumbai to Dhule cab service provides comfortable long-distance travel for passengers visiting Dhule from Mumbai. Our AC sedans and SUVs ensure smooth highway journeys and relaxed travel conditions. Professional drivers with route knowledge ensure safe and timely travel. Pickup is available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for family visits, business travel, and personal trips. Spacious seating ensures comfort throughout the journey. Flexible one-way and round-trip travel options are available. Reliable cab services ensure convenient travel between Mumbai and Dhule."
},
{
name: "Mumbai to Dhule Taxi",
description: "Mumbai to Dhule taxi service offers reliable transportation for passengers traveling across Maharashtra. Comfortable AC vehicles ensure pleasant highway travel experiences. Experienced drivers ensure safe driving and punctual arrival at the destination. Pickup services are available from homes, offices, hotels, and airport terminals across Mumbai. Ideal for families, tourists, and business travelers. Spacious seating and clean interiors ensure relaxed travel. Flexible scheduling allows passengers to plan trips conveniently. Professional taxi service ensures smooth and comfortable journeys."
},
{
name: "Mumbai to Dhule Cab Service",
description: "Mumbai to Dhule cab service provides dependable outstation travel for passengers planning long-distance journeys. Our fleet includes well-maintained AC sedans and SUVs designed for comfortable highway travel. Skilled drivers ensure safe driving and punctual travel schedules. Pickup is available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for family visits, corporate travel, and tourism. Spacious vehicles ensure comfortable seating for long-distance journeys. Flexible booking options make trip planning easy. Transparent pricing ensures reliable cab services."
},
{
name: "Mumbai to Dhule Taxi Fare",
description: "Mumbai to Dhule taxi fare is calculated using transparent per-kilometer pricing for a clear travel cost structure. Passengers can choose from multiple vehicle options depending on comfort and budget preferences. Our AC vehicles ensure smooth highway journeys and relaxed travel experiences. Experienced drivers ensure safe driving and timely arrival. Pickup services are available from homes, hotels, offices, and airports across Mumbai. Ideal for family travel and corporate visits. Flexible booking options allow convenient trip planning. Reliable fare structure ensures stress-free taxi booking."
},
{
name: "Mumbai to Dhule One Way Cab",
description: "Mumbai to Dhule one way cab service is ideal for passengers who require a drop service without paying return charges. This option helps reduce travel costs while ensuring comfortable transportation. AC sedans and SUVs provide relaxed seating for long-distance journeys. Professional drivers ensure safe highway driving and punctual arrivals. Pickup is available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for business trips and quick intercity travel. Flexible scheduling allows convenient departure times. Reliable one-way cab service ensures affordable and comfortable travel."
}
],

tableData: [
["Mumbai to Jalgaon Cab","Mumbai to Jalgaon Taxi"],
["Mumbai to Jalgaon Cab Service","Mumbai to Jalgaon Taxi Service"],
["Cab from Mumbai to Jalgaon","Taxi from Mumbai to Jalgaon"],
["Mumbai to Jalgaon Cab Booking","Mumbai to Jalgaon Taxi Booking Online"],
["Mumbai to Jalgaon Cab Price","Mumbai to Jalgaon Taxi Fare"],
["Mumbai to Dhule Cab","Mumbai to Dhule Taxi"],
["Mumbai to Dhule Cab Service","Mumbai to Dhule Taxi Fare"],
["Mumbai to Dhule One Way Cab","Best Cab Mumbai to Dhule"]
],




whychoose: [
  {
    WhyChooseheading: "Experienced Long-Distance Drivers",
    WhyChoosedescription: "Our drivers are highly experienced with long-distance highway travel between Mumbai, Jalgaon, and Dhule. They are familiar with NH160 and major connecting highways, ensuring a safe, smooth, and comfortable journey throughout the trip."
  },
  {
    WhyChooseheading: "Transparent Pricing",
    WhyChoosedescription: "Omshree Cabs follows a transparent pricing policy for Mumbai to Jalgaon and Dhule cab bookings. We clearly explain the per-kilometer fare, toll charges, and travel packages before confirmation so customers never face hidden charges."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Whether you want to travel early morning or overnight, Omshree Cabs provides round-the-clock cab booking and customer support for Mumbai to Jalgaon and Dhule travel."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "Our fleet includes well-maintained, fully air-conditioned vehicles designed for long-distance travel. Every car is thoroughly cleaned and sanitized before each trip to ensure a comfortable and hygienic ride."
  },
  {
    WhyChooseheading: "Flexible Travel Options",
    WhyChoosedescription: "We offer flexible trip options including one-way cabs, round trips, and multi-day travel packages. Travelers can customize pickup time, travel route, and return schedule according to their convenience."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Omshree Cabs provides a wide range of vehicles including sedan cars, spacious SUVs like Ertiga and Innova, and premium vehicles suitable for families and group travelers."
  },
  {
    WhyChooseheading: "Doorstep Pickup from Mumbai",
    WhyChoosedescription: "We offer convenient pickup from homes, hotels, offices, and airports anywhere in Mumbai. Our drivers arrive on time so your journey to Jalgaon or Dhule begins smoothly without travel hassle."
  },
  {
    WhyChooseheading: "Reliable & Punctual Service",
    WhyChoosedescription: "Omshree Cabs is known for dependable service and punctual pickups. Our drivers prioritize passenger safety and ensure you reach Jalgaon or Dhule comfortably and on time."
  }
]
};

const faqData = [
  { question: "What is the distance from Mumbai to Jalgaon by cab?", answer: "The distance from Mumbai to Jalgaon is approximately 420 km and the journey usually takes around 8–9 hours depending on traffic and road conditions." },
  { question: "What is the distance from Mumbai to Dhule by cab?", answer: "The distance from Mumbai to Dhule is approximately 320 km and the journey usually takes around 6–7 hours depending on traffic and road conditions." },
  { question: "Do you provide one-way Mumbai to Jalgaon or Dhule cab services?", answer: "Yes, Omshree Cabs provides both one-way and round-trip cab services between Mumbai, Jalgaon, and Dhule." },
  { question: "Which vehicles are available for this route?", answer: "We provide sedan cars, SUVs like Ertiga and Innova, and premium vehicles depending on your group size and travel comfort." },
  { question: "Is pickup available from Mumbai Airport?", answer: "Yes, we provide direct pickup from Mumbai Airport for Jalgaon and Dhule cab bookings." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Omshree Cabs are fully air-conditioned for comfortable long-distance travel." },
  { question: "Can we stop during the journey for food or rest?", answer: "Yes, passengers can request stops during the trip for meals, refreshments, or rest breaks." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially during weekends and holiday travel periods." },
  { question: "Do you offer round-trip packages?", answer: "Yes, Omshree Cabs offers round-trip and multi-day travel packages for Jalgaon and Dhule trips." },
  { question: "Are vehicles sanitized before travel?", answer: "Yes, all vehicles are cleaned and sanitized regularly to maintain passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Sunil Patil",
    feedback:
      "Booked Omshree Cabs for our Mumbai to Jalgaon trip. The driver was very professional and the car was clean and comfortable for the long journey.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Kavita Deshmukh",
    feedback:
      "Our family journey from Mumbai to Dhule with Omshree Cabs was smooth and stress-free. On-time pickup and transparent pricing made the trip excellent.",
    rating: 5
  }
];























































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];









const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Jalgaon / Dhule Cab Booking",
  "description": "Book Mumbai to Jalgaon and Dhule Cab with Omshree Cab for safe and comfortable outstation travel. Reliable taxi service with options for one-way or round trips from Mumbai to Jalgaon and Dhule. Affordable fares, easy online booking, and trusted cab service for your journey.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1800"
  }
};








  return (
    <div>
      
<Helmet>
  <title>Mumbai to Jalgaon / Dhule Cab Booking | Contact: +91 9892544084 | Omshree Cab</title>
  <meta 
    name="description" 
    content="Book Mumbai to Jalgaon and Dhule Cab with Omshree Cab for comfortable travel. Taxi service from Mumbai to Jalgaon and Dhule with one-way and round trip options. Affordable fares and easy online cab booking." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/16.jpeg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitojalgaoncabbookingdhule;